import { render, staticRenderFns } from "./BulkShelvesContent.vue?vue&type=template&id=231e4fc6&scoped=true"
import script from "./BulkShelvesContent.vue?vue&type=script&lang=js"
export * from "./BulkShelvesContent.vue?vue&type=script&lang=js"
import style0 from "./BulkShelvesContent.vue?vue&type=style&index=0&id=231e4fc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231e4fc6",
  null
  
)

export default component.exports